export default "__VITE_ASSET__B6AhhB6J__"